import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';
import VisibilityOn from '../../../assets/visibility_black_24dp.svg';
import VisibilityOffIcon from '../../../assets/visibility_off_black_24dp.svg';
import Close from '../CloseButton';
import Fade from '@material-ui/core/Fade';

import './styles.scss';
const Input = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className='input'>
      <input
        readOnly={props.readOnly}
        id={props.id}
        type={showPassword ? 'text' : props.type}
        required
        placeholder={props.placeholder}
        value={props.value}
        autoComplete='new-password'
        onChange={(e) => {
          props.setValue(e.target.value);
        }}
      />
      <Fade in>
        <span
          style={{
            position: 'absolute',
            top: '10px',
            right: '-15px',
            zIndex: '999999',
            cursor: 'pointer',
            visibility: props.value != '' ? 'visible' : 'hidden',
          }}
          onClick={() => {
            props.setValue('');
          }}
        >
          <Close
            tamanho='20px'
            tamanhoIcone='10px'
            corBackground='#ffffff'
            tabIndex='-1'
          />
        </span>
      </Fade>
      {props.required == 'true' && <label>Campo Obrigatório</label>}
      {props.type == 'password' && (
        <div
          onClick={() => {
            setShowPassword(!showPassword);
          }}
          className='input__showPass'
        >
          {showPassword ? (
            <ReactSVG
              beforeInjection={(svg) => {
                svg.classList.add('icon');
                svg.setAttribute('style', 'fill: #848484');
              }}
              src={VisibilityOn}
            />
          ) : (
            <ReactSVG
              beforeInjection={(svg) => {
                svg.classList.add('icon');
                svg.setAttribute('style', 'fill: #848484');
              }}
              src={VisibilityOffIcon}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Input;
